<template>
  <div class="flex flex-row justify-between items-center gap-2 font-rubik">
    <quote-summary-dropdown v-if="quote" />
    <button v-else 
      class="get-quote-button border rounded-full flex items-center justify-center" 
      data-vue-init="lead-flow" data-props='{ "gtag": "get_quote"}'
    >
      <span>Get Quote</span>
    </button>
  </div>
</template>

<script>
import QuoteSummaryDropdown from '../../quote/summary/dropdown.vue'
export default {
  components: {
    QuoteSummaryDropdown
  }
  
}
</script>

<style scoped>
  .get-quote-button {
    width: 119px;
    height: 40px;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: -0.04em;
    background-color: #ffffff;
    border: 1px solid #3565FC;
  }
  .get-quote-button span {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: -0.04em;
    color: #3565FC;
  }
</style>